export default __webpack_public_path__ + "static/invoicedetailbanner-ca6becfffc971b974f424e97234dfa01.svg";